export const Urls = {
    GetTopContributorsToEmissions: "MepInsights/GetTopContributorsToEmissions",
    GetSmallestContributorsToEmissions: "MepInsights/GetSmallestContributorsToEmissions",
    GetVesselEmissionsComparedWithTarget: "MepInsights/GetVesselEmissionsComparedWithTarget",
    GetCorrelationWithPortCallsAndTime: "MepInsights/GetCorrelationWithPortCallsAndTime",
    GetEmissionsByMonth: "MepInsights/GetEmissionsByMonth",
    GetLongTermForecast: "MepInsights/GetLongTermForecast"
  }

export enum MepCorrelationTypeEnum {
  Emissions = 1,
  PortCalls = 2,
  OperatingTime = 3
}